// Product icons JS placeholder.
(() => {
  const el = document.querySelector(".c-product-icons");
  if (!el) return;
})();

